import { createContext } from "react";

export const ZonasContext = createContext();
export const ZonasFormContext = createContext();
export const ZonasReportContext = createContext();
